import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setLanguage } from '@/shared/actions';
import { getLanguage } from '@/services/GNRL';
import { translate } from '@/services/TranslationService';
import {
  NovovilleButton,
  NovovilleInput,
  Typography,
} from '@/components/novoville';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import '../../output.css';
import AuthPageContainer from './AuthPageContainter';
import { hello } from './actions';
import ReCAPTCHAInput from './components/ReCAPTCHAInput';

const HelloPage = ({ history }) => {
  const [email, setEmail] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const dispatch = useDispatch();

  const initialLanguage = getLanguage();

  const [selectedLanguage, setSelectedLanguage] = useState(
    initialLanguage || ''
  );

  const handleLanguageChange = async (newLanguage) => {
    setSelectedLanguage(newLanguage);
    await dispatch(setLanguage(newLanguage));
  };

  const navigate = useCallback(
    (path) => {
      history.push(path);
    },
    [history]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const code = await dispatch(hello(email, recaptchaToken));

      if (code) {
        navigate(`/login-confirmation`);
        return;
      }

      navigate(`/registration-page`);
    } catch (error) {
      console.error('Error during hello action:', error);
    }
  };

  return (
    <AuthPageContainer
      language={selectedLanguage}
      handleLanguageChange={handleLanguageChange}
    >
      <Card className="h-full w-full sm:p-[40px] sm:drop-shadow-md drop-shadow-none shadow-none text-gray-800 px-[24px] border-none">
        <form className="flex flex-col h-full" onSubmit={handleSubmit}>
          <CardHeader className="text-center p-0 ">
            <CardTitle className="text-3xl ">
              <Typography variant="semibold_24">
                {translate('Hi There!')}
              </Typography>
            </CardTitle>
            <CardDescription className="mt-0">
              <Typography variant="regular_16">
                {translate('Please, enter your email to continue.')}
              </Typography>
            </CardDescription>
          </CardHeader>
          <CardContent className="my-8 p-0 flex flex-col space-y-4">
            <div>
              <Typography variant="semibold_14" className="mb-1">
                {translate('Email')}
              </Typography>
              <NovovilleInput
                type="email"
                label={translate('Email')}
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full"
              />
            </div>
            <ReCAPTCHAInput
              onVerify={(token) => {
                setRecaptchaToken(token);
              }}
            />
          </CardContent>
          <CardFooter className="p-0 flex flex-col justify-center items-center mt-auto">
            <NovovilleButton
              type="submit"
              variant="primary"
              className="w-full mb-4"
            >
              {translate('Continue')}
            </NovovilleButton>
          </CardFooter>
        </form>
      </Card>
    </AuthPageContainer>
  );
};

export default withRouter(HelloPage);
